module.exports = __webpack_public_path__ + "static/media/Portrait-10049.30f0f047.jpg";